<template>
  <div class="flex-align-center">
    <span
      v-if="isShowText"
      class="mg-r-8 fs-12">{{ switchValue==activeValue ? 'On' : 'Off' }}</span>
    <el-switch
      v-model="switchValue"
      :active-value="activeValue"
      :inactive-value="inactiveValue"
      :disabled="disabled"
      active-color="#DDF4FF"
      inactive-color="#AFB8C1"
      @change="changeValue"></el-switch>
  </div>
</template>

<script>
export default {
  name: 'v-text-switch',
  props:{
    value: {
      type: Number,
      default: 0
    },
    activeValue: {
      type: Number,
      default: 1
    },
    inactiveValue: {
      type: Number,
      default: 0
    },
    isShowText: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      switchValue: this.value
    }
  },
  watch: {
    value(status) {
      if(status !== this.switchValue) {
        this.switchValue = status
      }
    }
  },
  methods: {
    changeValue(status) {
      this.$emit('input', status)
      this.$emit('change', status)
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .el-switch{
  .el-switch__core{
    border-radius: 6px;
    border: 1px solid #AFB8C1;
    &:after{
      top: 0;
      border-radius: 6px;
      background: #F6F8FA;
      border: 1px solid #AFB8C1;
    }
    &:before{
      content: 'O';
      position: absolute;
      right: 5px;
      font-size: 12px;
    }
  }
  &.is-checked{
    .el-switch__core{
      //border: 1px solid #54AEF4;
      border-color:#0366D6!important;
      &:after{
        background: #0366D6;
      }
      &:before{
        content: 'I';
        color: #0969DA;
        left: 10px;
        right: auto;
        position: absolute;
      }
    }
  }

}
</style>
